// extracted by mini-css-extract-plugin
export default {"header__nav-item":"header__nav-item_JQX2BMSm"};